import * as React from 'react';
// import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
// import IconButton from '@mui/material/IconButton';
// import Tooltip from '@mui/material/Tooltip';
// import DeleteIcon from '@mui/icons-material/Delete';
import {HiSearch} from 'react-icons/hi'
import './dash.css'
interface Data {
    names: string;
    rooms: string;
    money: string;
    name: string;
    date: string;
    activity: string;
}

function createData(
    name: string,
    names: string,
    money: string,
    rooms: string,
    date: string,
    activity: string,
): Data {
    return {
        name,
        names,
        money,
        rooms,
        date,
        activity,
    };
}

const rows = [
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'cancelled'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'cancelled'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'cancelled'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
    createData('Jonathan Marnaud', '2 rooms', '120 $', '4 people', 'Oct 5th', 'active'),
];

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

type Order = 'asc' | 'desc';

function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
): (
        a: { [key in Key]: number | string },
        b: { [key in Key]: number | string },
    ) => number {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

interface HeadCell {
    disablePadding: boolean;
    id: keyof Data;
    //   label: string;
    numeric: boolean;
}

const headCells: readonly HeadCell[] = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        // label: 'Dessert (100g serving)',
    },
    {
        id: 'names',
        numeric: false,
        disablePadding: false,
        // label: 'names',
    },
    {
        id: 'money',
        numeric: false,
        disablePadding: false,
        // label: 'money (g)',
    },
    {
        id: 'rooms',
        numeric: false,
        disablePadding: false,
        // label: 'rooms (g)',
    },
    {
        id: 'date',
        numeric: false,
        disablePadding: false,
        // label: 'date (g)',
    },
];

interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    // onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
    // const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    //     props;
    // const createSortHandler =
    //     (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
    //         onRequestSort(event, property);
    //     };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    {/* <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    /> */}
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                    // sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {/* <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel> */}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

// interface EnhancedTableToolbarProps {
//     numSelected: number;
// }


export default function EnhancedTable() {
    const [order, setOrder] = React.useState<Order>('asc');
    const [orderBy, setOrderBy] = React.useState<keyof Data>('names');
    const [selected, setSelected] = React.useState<readonly string[]>([]);
    const [page, setPage] = React.useState(0);
    const rowsPerPage = (6);

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: keyof Data,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     if (event.target.checked) {
    //         const newSelected = rows.map((n) => n.names);
    //         setSelected(newSelected);
    //         return;
    //     }
    //     setSelected([]);
    // };

    const handleClick = (event: React.MouseEvent<unknown>, names: string) => {
        const selectedIndex = selected.indexOf(names);
        let newSelected: readonly string[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, names);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const isSelected = (names: string) => selected.indexOf(names) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;


    return (
        <Box sx={{}} className='sm:w-full w-[80vw]'>
            <div className='flex w-full justify-between mb-4'>
                <div className='font-bold'>Bookings</div>
                <div>
                    <input type="text" placeholder="Try parent's room" className='border p-1 rounded-xl outline-none' />
                </div>
            </div>
            <Paper sx={{ mb: 2 }}>
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                    // size={dense ? 'small' : 'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            // onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
              rows.sort(getComparator(order, orderBy)).slice() */}
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.names);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => handleClick(event, row.names)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.name}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                {row.names}
                                            </TableCell>
                                            <TableCell align="right">{row.names}</TableCell>
                                            <TableCell align="right">{row.money}</TableCell>
                                            <TableCell align="right">{row.rooms}</TableCell>
                                            <TableCell align="right">{row.date}</TableCell>
                                            <TableCell align="right" className=''><div className={`${row.activity === "active" ? "bg-green-200 text-green-400" : "bg-red-200 text-red-400"} w-24 mx-auto capitalize rounded-3xl text-white text-center py-1`}>{row.activity}</div></TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    labelRowsPerPage=''
                    rowsPerPageOptions={[]}
                />
            </Paper>
        </Box>
    );
}